/* projects/speaker-platform/src/app/pages/seance-on-air/seance-on-air.component.scss */
/*# sourceMappingURL=seance-on-air.component-BNAMXRO5.css.map */
